module.exports = __webpack_public_path__ + "img/cert_bg_2.1f011660.jpg";